export const PrizesTableHeader = [{ title: 'ID' }, { title: 'Уровень' }, { title: 'Количество' }];
